import { render, staticRenderFns } from "./CurationB.vue?vue&type=template&id=30c63d8e&scoped=true&"
import script from "./CurationB.vue?vue&type=script&lang=js&"
export * from "./CurationB.vue?vue&type=script&lang=js&"
import style0 from "./CurationB.vue?vue&type=style&index=0&id=30c63d8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c63d8e",
  null
  
)

export default component.exports